import React, { useEffect, useState, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,
} from "../Services/Urls";

import { callApi, makeApiRequest } from "../Services/ApiService";
import { decryptOtp } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { getRecords, PostRecords } from "../Services/ApiCall";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { ApiContext } from "../Context/Context";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const dialogStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "8px",
  width: "60vw",
};

const optionStyle = {
  padding: "10px",
  borderBottom: "1px solid #ddd",
  cursor: "pointer",
};
const closeBtn = {
  float: "right",
  marginTop: -18,
  fontSize: 18,
  marginRight: -8,
};

const SelectDialog = ({
  open,
  title,
  placeholder = "Search",

  onClose,
  selectedCity,
  selectedLocality,
  selectedArea,
  dataFlag,
  onSelect,
}) => {
  const { coordinates } = useContext(ApiContext);

  const [options, setOptions] = useState([]);
  const [query, setQuery] = React.useState("");

  useEffect(() => {
    getData();
  }, []);

  //console.log("coordinates:", coordinates);

  const getData = () => {
    let tabID =
      dataFlag === 1
        ? 260
        : dataFlag === 2
        ? 383
        : dataFlag === 3
        ? 424
        : dataFlag === 4
        ? 422
        : dataFlag === 5
        ? 423
        : dataFlag === 6
        ? 421
        : 260;
    let filterString =
      dataFlag === 1
        ? coordinates != null
          ? JSON.stringify({
              Coordinates: {
                $nearSphere: {
                  $geometry: {
                    type: "Point",
                    coordinates: [coordinates.longitude, coordinates.latitude],
                  },
                  $maxDistance: 3000000,
                },
              },
            })
          : `{}`
        : dataFlag === 2
        ? `{CityID: { $in: [${selectedCity?.CityID}] }}`
        : dataFlag === 3
        ? `{LocalityID: { $in: [${selectedLocality?.LocalityID}] }}`
        : `{}`;

    getRecords(tabID, 1000, filterString, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setOptions(data?.response?.records || []);
        } else {
          setOptions([]);
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const getOptionLabel = (option) => {
    switch (dataFlag) {
      case 1:
        return `${option.City}, ${option.State}`;
      case 2:
        return option.Locality;
      case 3:
        return option.SubArea;
      case 4:
        return option.MealOffering;
      case 5:
        return option.CommonArea;
      case 6:
        return option.RoomType;
      default:
        return option.City;
    }
  };

  const gettitle = (dataFlag) => {
    switch (dataFlag) {
      case 1:
        return `Select City`;
      case 2:
        return `Select Locality`;
      case 3:
        return `Select Area`;
      case 4:
        return `Select Meals Offerings`;
      case 5:
        return `Select Common Areas`;
      case 6:
        return `Select Room Type`;
      default:
        return `Select Item`;
    }
  };

  const filteredOptions = options?.filter((option) =>
    getOptionLabel(option)?.toLowerCase().includes(query.toLowerCase())
  );

  if (!open) return null;

  return (
    <div style={overlayStyle}>
      <div style={dialogStyle} className="dialoggs">
        <div style={closeBtn}>
          <i className="ri-close-line" onClick={onClose} />
        </div>

        <div className="form-group">
          <input
            className="input"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
          />
        </div>

        <h5>{gettitle(dataFlag)}</h5>

        <div className="dialogcontent">
          {filteredOptions?.map((option, index) => (
            <div
              key={index}
              style={{
                ...optionStyle,
                backgroundColor:
                  (dataFlag === 4 || dataFlag === 5 || dataFlag === 6) &&
                  selectedArea?.some((item) => item.ID === option?.ID)
                    ? "#eaf8f0"
                    : "transparent",
              }}
              onClick={() => onSelect(option)}
            >
              {getOptionLabel(option)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectDialog;
